import { connect } from 'react-redux';
import {requestTickets,requestContact,addTicket,uploadImage,addTicketWithAttchment} from '../modules/support';
import AddNewTicketForm from '../components/AddNewTicketForm';

const mapDispatchToProps = {
  requestTickets,
  requestContact,
  addTicket,
  uploadImage,
  addTicketWithAttchment
};

const mapStateToProps = (state, ownProps) => ({
  tickets: state.support.tickets
});

export default connect(mapStateToProps, mapDispatchToProps)(AddNewTicketForm);



// WEBPACK FOOTER //
// src/routes/support/containers/CreateTicketContainer.js